import { BaseModel } from './basemodel';

export enum EndpointMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
  PATCH = 'PATCH',
  TRACE = 'TRACE',
}

export interface DataConnectionEndpoint extends BaseModel {
  identifier: string;

  url: string;

  method: EndpointMethod;

  preprocess: string;

  postprocess: string;

  body: string;

  header: { key: string; value: string }[];

  query: { key: string; value: string }[];

  isLocal?: boolean;
}
